import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';
import { OnboardingMachineContext } from 'components/onboarding/onboarding.machine';
import { PlanSwitcherGate } from 'components/plan-switcher-gate/plan-switcher-gate.component';

// Returning-login Plan Switcher gate (GEIS-498). Surfaced once after a returning
// member's onboarding is already complete, before Home. On the gate's
// "/member/home" completion deeplink this routes Home (web serves it at HOME;
// see GEIS-492) — the default deeplink behaviour, unlike the first-login step
// which advances onboarding — then finishes the onboarding machine so the
// requested route renders. Mirrors iOS AuthenticatedCoordinator.presentPlanSwitcher.
export const ReturningPlanSwitcherView = () => {
  const { send } = OnboardingMachineContext.useActorRef();
  const navigate = useNavigate();

  const handleComplete = useCallback(() => {
    // Intentional: the returning gate always routes Home on completion,
    // overriding any non-home destination the member was deep-linking to.
    // Mirrors the iOS gate-before-Home behaviour (the gate sits in front of
    // Home for returning members, so completion lands on Home).
    navigate(APP_MANAGED_ROUTES.HOME);
    send({ type: 'navigateToNextView' });
  }, [navigate, send]);

  return <PlanSwitcherGate onComplete={handleComplete} />;
};
